import { type Common } from './common.js';
import type {
  AgentConversationBrowserNotification,
  BrowserNotificationQuery,
} from './models/notification/browserNotification.js';
import type { PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import type { PaginationResponse } from './models/pagination/PaginationResponse.type.js';

export class API {
  common: Common;
  baseEndpoint = '/notifications';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    options?: PaginatedQueryOptions<BrowserNotificationQuery>
  ): Promise<PaginationResponse<AgentConversationBrowserNotification>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }
}
